import { render, staticRenderFns } from "./UtilisateurDetail.vue?vue&type=template&id=470a8938&"
import script from "./UtilisateurDetail.vue?vue&type=script&lang=js&"
export * from "./UtilisateurDetail.vue?vue&type=script&lang=js&"
import style0 from "./UtilisateurDetail.vue?vue&type=style&index=0&id=470a8938&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports